<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <ValidationProvider
      v-slot="v"
      :rules="rules"
    >
      <!-- <label :class="{ required: required }" class="form-label" :for="name">{{ label }}</label> -->
      <!-- <div v-for="(lb, index) in label" :key="index">
        <label :key="index" :class="{ required: required }" class="form-label" :for="name">{{ lb }}</label>
      </div> -->

      <!-- <label :class="{ required: required }" class="form-label" :for="name">
        <div v-for="(lb, index) in label" :key="index">
          {{ lb }}
        </div>
      </label> -->

      <label
        class="form-label"
        :for="name"
      >
        <div
          v-for="(lb, index) in label"
          :key="index"
          :class="{'required': index === 0 && required}"
        >
          {{ lb }}
        </div>
      </label>

      <slot />
      <span
        v-if="v.validated && v.invalid"
        class="input-error"
        v-html="v.errors[0]"
      />
    </ValidationProvider>
  </div>
</template>

<script>
	export default {
		name: 'AppInput',
		props: {
			label: {
				type: [String, Array],
				required: true,
			},
			name: {
				type: String,
				required: true,
			},
			rules: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				isPdfPreview: false,
			}
		},
		computed: {
			required() {
				return this.rules && this.rules.indexOf('required') >= 0
			},
		},
		mounted() {
			let inputElement = this.$el.getElementsByTagName('input')[0] || this.$el.getElementsByTagName('select')[0]
			if (inputElement) {
				inputElement.id = this.name
				inputElement.setAttribute('name', this.name)
			}
		},
	}
</script>

<style lang="scss">
	.required:after {
	content: ' *';
	color: red;
	}
</style>
